import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {SharedModule} from './shared/shared.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {LoginPageComponent} from './login-page/login-page.component';
import {DashboardComponent} from './shared/dashboard/dashboard.component';
import {AccordionMenuComponent} from './shared/dashboard/accordion-menu/accordion-menu.component';
import {OAuthModule} from 'angular-oauth2-oidc';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {SampleApplicationComponent} from './sample-application/sample-application.component';
import {httpInterceptorProviders} from './interceptors';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {ChangeLanguageComponent} from './shared/dashboard/change-language/change-language.component';
import {MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {DialogService} from './shared/confirm-dialog/dialog.service';
import {CookieConsentDialogComponent} from './cookie-consent-dialog/cookie-consent-dialog.component';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgxHotjarModule, NgxHotjarRouterModule} from 'ngx-hotjar';
import {environment} from '../environments/environment';
import {COOKIE_CONSENT, getCookie} from './config/cookies.config';
import { ChangePasswordPageComponent } from './change-password-page/change-password-page.component';
import { TokenBaselinkerPageComponent } from './token-baselinker-page/token-baselinker-page.component';
import { DialogRefreshTokenComponent } from './token-baselinker-page/dialog-refresh-token/dialog-refresh-token.component';
import { NotificationBarComponent } from './shared/dashboard/notification-bar/notification-bar.component';
import { KnsSnackbarModule } from '@kns-jasfbg/kns-snackbar';
import { DummyRedirectComponent } from './dummy-redirect-component';
import { RouteReuseStrategy } from '@angular/router';
import { CustomRouteReuseStrategy } from '@kns-jasfbg/feature-shipment';
import { SignalRLogoutService } from './services/signalr-logout.service';
import { authInitProvider } from './config/auth-init.factory';
import { CookieConsentComponent } from './cookie-consent/cookie-consent.component';
import { shipmentApiUrlInitProvider } from './config/shipment-api-url-init.factory';
import { HELP_API_URL } from '@jas-fbg-sa/feature-help';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(
    http,
    './assets/i18n/',
    `.json?v=${Date.now()}`
  );
}

let hotjarModules = [];

if (environment.production && getCookie(COOKIE_CONSENT) && getCookie(COOKIE_CONSENT).split('|')[1] === '1') {
  hotjarModules = [NgxHotjarModule.forRoot(environment.hj), NgxHotjarRouterModule];
}

@NgModule({
  declarations: [
    AppComponent,
    LoginPageComponent,
    CookieConsentComponent,
    DashboardComponent,
    ChangeLanguageComponent,
    NotificationBarComponent,
    AccordionMenuComponent,
    SampleApplicationComponent,
    CookieConsentDialogComponent,
    ChangePasswordPageComponent,
    TokenBaselinkerPageComponent,
    DialogRefreshTokenComponent,
    DummyRedirectComponent
  ],
  bootstrap: [AppComponent], imports: [BrowserModule,
    FormsModule,
    AppRoutingModule,
    SharedModule,
    BrowserAnimationsModule,
    KnsSnackbarModule,
    MatDialogModule,
    MatSlideToggleModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    ...hotjarModules,
    OAuthModule.forRoot(),
    ReactiveFormsModule],
  providers: [
    httpInterceptorProviders,
    DialogService,
    SignalRLogoutService,
    { provide: HELP_API_URL, useValue: environment.helpApiUrl },
    { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
    authInitProvider,
    shipmentApiUrlInitProvider,
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule {
}
